export enum UserStatusText {
  ACTIVE = 'Active',
  PENDING_FIRST_LOGIN = 'Pending first login',
  INACTIVE = 'Inactive',
}
